module.exports = __webpack_public_path__ + "img/watercolor_black.0238126.svg";